$(document).on('click', '.del-tourist', function () {
    let allTourists = $('.block-tourist');
    if (allTourists.length > 0) {
        $(this).closest('.block-tourist').remove();
        calculateOrder();
    }
    countTouristsFoDel();
    updateTourist();
});
$(document).on('click', '.checkout_popup-close,.btn-close-popup', function () {
    $('.checkout_popup').fadeOut('fast');
    return false;
});

$(document).on('click', '.add-tourist', function (e) {
    e.preventDefault();

    if ($('.block-tourist').length === 0) {
        let insurer_fname = $('#insurer_fname').val();
        let insurer_lname = $('#insurer_lname').val();
        let insurer_passport = $('#insurer_passport').val();
        let insurer_bdate = $('#insurer_bdate').val();
        $('.block-tourists').append(`
                            <div class="block-tourist">
                              <div class="inner-tourist">
                              <h5 class="title-tourist__number">${touristTrip}: № <span class="count-tourist"></span></h5>
                                <span class='del-tourist'></span>
                                <div class="crow">
                                    <label>
                                        <input type="text" value="${insurer_fname}" class="tourist_name form-control__name" placeholder="${first_name}" name="tourist_fname[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-name"></span>
                                        <span class="error">
                                    </label>
                                    <label>
                                        <input type="text" value="${insurer_lname}" class="tourist_surname form-control__surname" placeholder="${last_name}" name="tourist_lname[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-surname"></span>
                                        <span class="error">
                                    </label>
                                </div>
                                <div class="crow">
                                    <label>
                                        <input type="text" value="${insurer_passport}" class="tourist_passport form-control__pasport" placeholder="${passport}" name="tourist_passport[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-passport"></span>
                                        <span class="error">
                                    </label>
                                    <label>
                                        <input type="text" value="${insurer_bdate}" class="tourist_birthday" placeholder="${birthday}" name="tourist_bdate[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-birthday"></span>
                                        <span class="error">
                                    </label>
                                </div>
                              </div>
                            </div>
                        
                            <div class="block-tourist">
                       <div class="inner-tourist">
                            <h5 class="title-tourist__number">${touristTrip}: № <span class="count-tourist"></span></h5>
                                <span class='del-tourist'></span>
                                <div class="crow">
                                    <label>
                                        <input type="text" class="tourist_name form-control__name" placeholder="${first_name}" name="tourist_fname[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-name"></span>
                                        <span class="error">
                                    </label>
                                    <label>
                                        <input type="text" class="tourist_surname"  placeholder="${last_name}" name="tourist_lname[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-surname"></span>
                                        <span class="error">
                                    </label>
                                </div>
                                <div class="crow">
                                    <label>
                                        <input type="text" class="tourist_passport" placeholder="${passport}" name="tourist_passport[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-passport"></span>
                                        <span class="error">
                                    </label>
                                    <label>
                                        <input type="text" class="tourist_birthday" placeholder="${birthday}" name="tourist_bdate[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-birthday"></span>
                                        <span class="error">
                                    </label>
                                </div>
                               </div> 
                            </div>
`);
    } else {
        $('.block-tourists').append(`<div class="block-tourist">

                               <div class="inner-tourist">
                               <h5 class="title-tourist__number">${touristTrip}: № <span class="count-tourist"></span></h5>
                                <span class='del-tourist'></span>
                                <div class="crow">
                                    <label>
                                        <input type="text" class="tourist_name form-control__name" placeholder="${first_name}" name="tourist_fname[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-name"></span>
                                        <span class="error">
                                    </label>
                                    <label>
                                        <input type="text" class="tourist_surname" placeholder="${last_name}" name="tourist_lname[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-surname"></span>
                                        <span class="error">
                                    </label>
                                </div>
                                <div class="crow">
                                    <label>
                                        <input type="text" class="tourist_passport" placeholder="${passport}" name="tourist_passport[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-passport"></span>
                                        <span class="error">
                                    </label>
                                    <label>
                                        <input type="text" class="tourist_birthday" placeholder="${birthday}" name="tourist_bdate[]" autocomplete="off" data-req="1" data-validate="1">
                                        <span class="warn-icon" for="user-birthday"></span>
                                        <span class="error">
                                    </label>
                                </div>
                                </div>
                            </div>`);
    }
    $('.tourist_birthday').mask("99.99.9999", { placeholder: 'DD.MM.YYYY' });
    countTouristsFoDel();
    updateTourist();
    return false;
});

function updateTourist() {
    $('.block-tourist').each(function (i) {
        $(this).find('.count-tourist').html(i + 1)
    });
}


$('.block-tourists').on('change', 'input', function (e) {
    if ($(e.target).val() !== "") {
        $(e.currentTarget).css('border-bottom', '3px solid green');
        $('.age-tourists').css('display','none');
    }if ($(e.target).val() === "") {
        $(e.currentTarget).css('border-bottom', '3px solid red');
    }
});
$('.checkout_form2').on('change', 'input', function (e) {
    if ($(e.target).val() !== "") {
        $(e.currentTarget).css('border', '');
    }
});
$('#checkbox2').on('change', function (e) {
    if ($('#checkbox2').prop("checked")) {
        $($('label[for=checkbox2]')[0]).css({'color': '', 'text-decoration': ''});
    }
});
$('#insurer_phone, #insurer_email, #get_full_number_insurer').on('change', function () {
    let request = getOrderDetails();
    let send_data = {
        'request': request
    };
    $.post('/api/tempOrder', JSON.stringify(send_data), function () {

    });
});
$(document).ready(function () {
    let lang = localStorage.getItem('lang');
    $('.calendar').daterangepicker({
        linkedCalendars: false,
        autoApply: true,
        showDropdowns: true,
        minDate: new Date(),
        startDate: getDateAddDays(1, true),
        endDate: getDateAddDays(7, true),
        maxSpan: {
            "days": 364
        },
        locale: {
            cancelLabel: localStorage.getItem(`cancel`),
            applyLabel: localStorage.getItem(`apply`)
        }
    }, function (start,end) {
        const startDate = `${start._d.getDate()}.${start._d.getMonth()+1}.${start._d.getFullYear()}`;
        const endDate = `${end._d.getDate()}.${end._d.getMonth()+1}.${end._d.getFullYear()}`;
        if (startDate===endDate) {
            const endChangeDate = `${end._d.getDate()+1}.${end._d.getMonth()+1}.${end._d.getFullYear()}`;
            $(".calendar").data('daterangepicker').setEndDate(endChangeDate);
        }
    });
});

let glob_payment_link = '';
let order_id = '';
// $('#buy_police').on('click', function (e) {
//     e.preventDefault();
//     let order_info = getOrderInfo();
//     if (order_info.success) {
//         let send_data = {
//             'request': order_info.data
//         };
//         $.post('/api/createOrder', JSON.stringify(send_data), function (res) {
//             if(res.payment_link){
//                 $('#sign-email').html(order_info.data.insurer.email);
//                 openModal();
//                 glob_payment_link = res.payment_link;
//                 order_id = res.order_id;
//                 //window.open(res.payment_link, '_self');
//             }
//             // let payment_info = res.payment_info;
//             // pay(payment_info);
//         });
//     }
// });

$('#buy_police').on('click', function (e) {
    e.preventDefault();
    const { success, data } = getOrderInfo();
    const countries = multiSelect.getSelectEntries()
        .map(([_, id]) => `${id}`);
    const additional_services = getSelectedAdditionOptions()
        .map(([id]) => id);

    if (success && countries.length) {
        let send_data = {
            request: {
                additional_services,
                already_traveling: false,
                countries,
                date_from: data.date_from,
                date_to: data.date_to,
                discount_available: false,
                insurer: normalizePerson(data.insurer),
                tourists: data.tourists.map(person => normalizePerson(person)),
                program_id: 1,
                promo_code: null,
                travel_type: data.sport,
                year_program: false,
            }
        };

        showLoader();
        $.post('/api/create_policy', JSON.stringify(send_data), function (res) {
            const { success, payment_link, order_id } = res;

            if (success) {
                checkPaymentStatus(order_id);
                window.open(payment_link, "_blank") || window.location.replace(payment_link);
            } else {
                hideLoader();
            }
        });
    }
});

$('#signPolice').on('click', function () {
    const code = document.getElementById('codeInput').value.trim();
    let send_data = {
        'code': code,
        'order_id': order_id,
    };
    $.post('/api/signOrder', JSON.stringify(send_data), function (res) {
        if(res.success){
            window.open(glob_payment_link, '_self');
        }
    });
});

$('#successPayment').on('hidden.bs.modal', function () {
    location.reload();
});
$('#declinePayment').on('hidden.bs.modal', function () {
    location.reload();
});
$('#processPayment').on('hidden.bs.modal', function () {
    location.reload();
});
$('a.dropdown-item').on('click', function (e) {
    let href = $(e)[0].target.hash;
    let res;
    if (typeof href !== 'string') {
        res = [null, 'ua'];
    } else {
        res = href.match(/^#lang_(\w+)$/);
    }
    if (res !== null) {
        $.get(`/api/change_lang/${res[1]}`, function () {
            location.replace('/');
        });
    }
});

$('.checkout_form2').on('change', 'input', function () {
    calculateOrder();
});
$('.checkout_form2').on('click', 'input[name="is_insurer[]"]', function (e) {
    let elem = $(e.target);
    let allCheckBox = $('.checkout_form2 input[name="is_insurer[]"]');
    for (let i = 0; i < allCheckBox.length; i++) {
        if ($(allCheckBox[i])[0].id === elem[0].id) {
            continue;
        } else {
            $(allCheckBox[i]).prop("checked", false);
        }
    }
    if (elem[0].checked) {
        let obj = elem.parent().parent();
        let fname_el = obj.find('input[name="tourist_fname[]"]');
        let fname = fname_el.val();
        let lname_el = obj.find('input[name="tourist_lname[]"]');
        let lname = lname_el.val();
        let passport_el = obj.find('input[name="tourist_passport[]"]');
        let passport = passport_el.val();
        let bdate_el = obj.find('input[name="tourist_bdate[]"]');
        let bdate = bdate_el.val();
        let ins_fname = $('#insurer_fname');
        ins_fname.val(fname);
        ins_fname.trigger('change');
        let ins_lname = $('#insurer_lname');
        ins_lname.val(lname);
        ins_lname.trigger('change');
        let ins_passport = $('#insurer_passport');
        ins_passport.val(passport);
        ins_passport.trigger('change');
        let ins_bdate = $('#insurer_bdate');
        ins_bdate.val(bdate);
        ins_bdate.trigger('change');
        initInsurerDate();
    }
});

$('div.mob-menu__close').on('click', function () {
    $('.mob-menu').removeClass('open');
});
$('#tour_direct').on('change', function () {
    setTerritory();
    calculateOrder();
});

$('#period_tour, #insurer_bdate').on('change', function () {
    calculateOrder();
});

$('.block-tourists').on('change', '.tourist_birthday, .tourist_passport, .tourist_surname, .tourist_name', function () {
    calculateOrder();
});

$('#active_sport').on('change', function () {
    setSportSelected();
    calculateOrder();
});

function setTerritory() {
    let territory = $('#tour_direct option:selected').text();
    $('span.police_territory').html(territory);
}

function setSportSelected() {
    let lang = localStorage.getItem('lang');
    let sport = $('#active_sport').val();
    let sport_text = sport === '1' ? localStorage.getItem(`no_low`) : localStorage.getItem(`yes_low`);
    $('span.active_sport').html(sport_text);
}

function getDateAddDays(add_days = 1, calendar = false) {
    let d = new Date();
    d.setDate(d.getDate() + add_days);
    let year = d.getFullYear();
    let month = addZero(d.getMonth() + 1);
    let day = addZero(d.getDate());
    if (calendar) {
        return "" + day + "/" + month + "/" + year;
    } else {
        return "" + year + "-" + month + "-" + day;
    }
}

function setCountDays(date_from = null, date_to = null) {
    if (date_from !== null && date_to !== null) {
        let from_unix = parseInt(new Date(date_from).getTime() / 1000);
        let to_unix = parseInt(new Date(date_to).getTime() / 1000);
        let unix_diff = to_unix - from_unix;
        let days_diff = 1;
        if (unix_diff > 0) {
            days_diff = unix_diff / (60 * 60 * 24) + 1;
        }
        $('.body-form-days span').html(days_diff);
    }
    return false;
}

function getDates() {
    let date_str = $('#period_tour').val();
    let dates = date_str.split('-');
    let date_from;
    let date_to;
    if (dates.length >= 2) {
        date_from = getDateForRequest(dates[0].trim());
        date_to = getDateForRequest(dates[1].trim());
    } else {
        date_from = getDateAddDays(1);
        date_to = getDateAddDays(4);
    }
    setCountDays(date_from, date_to);
    return {
        'date_from': date_from,
        'date_to': date_to
    }
}

function addZero(num) {
    return num < 10 ? '0' + num : num;
}

function getDateForRequest(date = null) {
    if (date === null) {
        return date;
    } else {
        let year = date.substr(6, 4);
        let month = date.substr(3, 2);
        let day = date.substr(0, 2);
        return "" + year + "-" + month + "-" + day;
    }
}

// function calculateOrder() {
//     let dates = getDates();
//     let allTourists = getTourists();
//     let territory = $('#tour_direct').val();
//     let date_from = dates.date_from;
//     let date_to = dates.date_to;
//     let tourists = allTourists;
//     let sport = $('#active_sport').val();
//     let info = {};
//     info.territory = territory;
//     info.date_from = date_from;
//     info.date_to = date_to;
//     info.tourists = tourists;
//     info.sport = sport;
//     let request = {
//         'request': info
//     };
//     $.post('/api/calculate', JSON.stringify(request), function (res) {
//         if (res.success) {
//             let data = res.data;
//             if (data.success) {
//                 $('span.police_price').html(data.info.cost);
//             }
//         }
//     });
// }

function calculateOrder() {
    let dates = getDates();
    let allTourists = getTourists();
    let territory = $('#tour_direct').val();
    let date_from = dates.date_from;
    let date_to = dates.date_to;
    let tourists = allTourists;
    let travel_type = $('#active_sport').val();
    const countries = multiSelect.getSelectEntries()
        .map(([_, id]) => `${id}`);
    const additional_services = getSelectedAdditionOptions()
        .map(([id]) => id);
    
    let request = {
        request: {
            additional_services,
            already_traveling: false,
            countries,
            date_from,
            date_to,
            discount_available: false,
            particular_tourists: tourists.map(person => normalizePerson(person)),
            program_id: 1,
            promo_code: null,
            travel_type,
            year_program: false,
        }
    };

    if (!countries.length) {
        $('span.police_price').html('');
        updateInfoESIM(null);

        return;
    }
    
    $.post('/api/get_policy_price', JSON.stringify(request), function (res) {
        const { success, data } = res;
        
        if (success) {
            $('span.police_price').html((data[0].total_amount));
            updateInfoESIM(data[0].esim_info);
        }
    });
}

function bytesToStr(bytes) {
	const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'];
	let i = 0;

	while (bytes >= 1024 && i < units.length - 1) {
		bytes /= 1024;
		i++;
	}

	return `${bytes % 1 === 0 ? bytes : bytes.toFixed(2)}${units[i]}`;
}

function replaceTextVariables(text, variables = {}) {
	return text.replace(/\{\{(\w+)}}/g, (_, key) => variables[key] ?? '');
}

function formatESIMCountryNames(countries) {
	const limit = 3;
	const visibleCountries = countries.slice(0, limit).join(', ');
	const remainingCount = countries.length - limit;

	if (remainingCount <= 0) {
		return visibleCountries;
	}

	return `${visibleCountries} +${remainingCount}`;
}

function setMessageESIM(countries, esim_info) {
	const countriesList = formatESIMCountryNames(countries);

	if (!esim_info) {
		// const notServed = countries.length === 1 ? 'eSIM {{countries}} is not served' : 'eSIM {{countries}} are not served';
		const notServed = 'eSIM is not served';

		return replaceTextVariables(notServed, { countries: countriesList });
	}

	const { count_bytes, duration, paid_esim } = esim_info;
	// const served = paid_esim ? 'eSIM {{countries}}, {{bytes}} / {{duration}} days. Included' :  'eSIM {{countries}}, {{bytes}} / {{duration}} days';
	const served = paid_esim ? 'eSIM {{bytes}} / {{duration}} days. Included' :  'eSIM {{bytes}} / {{duration}} days';

	return replaceTextVariables(served, {
		countries: countriesList,
		bytes: bytesToStr(count_bytes),
		duration,
	});
}
function updateInfoESIM(esim_info) {
	const { getSelectEntries } = multiSelect
	const labelElement = document.querySelector('span[data-esim]');
	const countries = getSelectEntries().map(([text]) => text.replace(/\s*\([^)]*\)/g, '').trim());
	const message = setMessageESIM(countries, esim_info);

	labelElement.textContent = message;
    updateCountriesPopupTitle(message);
}


function updateCountriesPopupTitle(text) {
    const countriesRestWindow = document.querySelector('.countries-rest');
    const h4 = countriesRestWindow.getElementsByTagName('h4')[0];

    h4 && (h4.textContent = `${text} ${h4.dataset.text}`);
}

function normalizeDate (date) {
	return date.split('-').reverse().join('-');
}

function normalizePerson (person) {
	const normalizedPerson = {}
	const associations = {
		birthday: 'date_birth',
		fname: 'first_name',
		lname: 'last_name',
        birth_date: 'date_birth',
	}

	for (const prop in person) {
		if (associations.hasOwnProperty(prop)) {
			normalizedPerson[associations[prop]] = person[prop];
		} else {
			normalizedPerson[prop] = person[prop];
		}
	}

    // if (normalizedPerson.date_birth) {
	// 	normalizedPerson.date_birth = normalizeDate(normalizedPerson.date_birth);
	// }

	return normalizedPerson;
}

function getTourists() {
    let allTourists = [];
    let allElements = $('.inner-tourist');
    for (let i = 0; i < allElements.length; i++) {
        let eachElem = $(allElements[i]);
        let tourist_fname_el = eachElem.find('input[name="tourist_fname[]"]');
        let tourist_fname = tourist_fname_el.val();
        let tourist_lname_el = eachElem.find('input[name="tourist_lname[]"]');
        let tourist_lname = tourist_lname_el.val();
        let tourist_passport_el = eachElem.find('input[name="tourist_passport[]"]');
        let tourist_passport = tourist_passport_el.val();
        let tourist_bdate_el = eachElem.find('input[name="tourist_bdate[]"]');
        let tourist_bdate = tourist_bdate_el.val();
        let each_obj = {
            "fname": tourist_fname,
            "lname": tourist_lname,
            "birthday": getDateForRequest(tourist_bdate),
            "passport": tourist_passport
        };
        if (tourist_fname !== "" && tourist_lname !== "" && tourist_passport !== "" && tourist_bdate !== "") {
            allTourists.push(each_obj);
        } else {

        }
    }
    if (allTourists.length === 0) {
        if ($('#insurer_bdate').val() !== '') {
            allTourists.push({
                "lname": $('#insurer_lname').val(),
                "fname": $('#insurer_fname').val(),
                "passport": $('#insurer_passport').val(),
                "birthday": getDateForRequest($('#insurer_bdate').val())
            });
        } else {
            allTourists.push({
                "lname": $('#insurer_lname').val(),
                "fname": $('#insurer_fname').val(),
                "passport": $('#insurer_passport').val(),
                "birthday": '1985-01-01'
            });
        }

    }
    $('span.count_tourists').html(allTourists.length);
    return allTourists;
}

function getOtherDate(date_str) {
    let d = new Date(date_str);
    let year = d.getFullYear();
    let month = addZero(d.getMonth() + 1);
    let day = addZero(d.getDate());
    return "" + day + "." + month + "." + year;
}

function getOrderInfo() {
    if (checkAllFields()) {
        return {
            'success': true,
            'data': getOrderDetails()
        };
    } else {
        return {
            'success': false
        };
    }
}

function getOrderDetails() {
    let dates = getDates();
    let allTourists = getTourists();
    let direct = $('#tour_direct').val();
    let active_sport = $('#active_sport').val();
    let insurer = {
        'first_name': $('#insurer_fname').val(),
        'last_name': $('#insurer_lname').val(),
        'passport': $('#insurer_passport').val(),
        'birth_date': getDateForRequest($('#insurer_bdate').val()),
        'phone': $('#get_full_number_insurer').val(),
        'email': $('#insurer_email').val()
    };
    let order_info = {
        'date_from': dates.date_from,
        'date_to': dates.date_to,
        'insurer': insurer,
        'tourists': allTourists,
        'territory': direct,
        'sport': active_sport
    };
    return order_info;
}

function checkAllFields() {
    // let correct_direct = false;
    let correct_direct = true;
    let correct_dates = false;
    let correct_sport = false;
    let insurer_correct = false;
    let tourists_list = false;
    let accept_terms = false;
    let all_right = false;
    let direct_el = $('#tour_direct');
    let period_tour = $('#period_tour');
    let tourists_list_el = $('.checkout_form2');
    let direct_val = direct_el.val();
    let active_sport = $('#active_sport');
    let insurer_el = $('.checkout_form3');
    let terms_el = $('.checkout_total > .checkout_checkbox');
    let insurer = {
        'insurer_fname': $('#insurer_fname').val(),
        'insurer_lname': $('#insurer_lname').val(),
        'insurer_passport': $('#insurer_passport').val(),
        'insurer_bdate': getDateForRequest($('#insurer_bdate').val()),
        'insurer_phone': $('#insurer_phone').val(),
        'insurer_email': $('#insurer_email').val()
    };
    let dates = getDates();
    // if (direct_val !== 'none' && direct_val !== "") {
    //     correct_direct = true;
    // }
    if (active_sport.val() !== 'none' && active_sport.val() !== "") {
        correct_sport = true;
    }
    if (checkCorrectDateFrom(dates.date_from) && checkCorrectDateTo(dates.date_from, dates.date_to)) {
        correct_dates = true;
    }
    if (checkNotEmptyAllFields(insurer)) {
        insurer_correct = true;
    }
    if (checkCorrectTouristsList()) {
        tourists_list = true;
    }
    if ($('#checkbox2').prop("checked")) {
        accept_terms = true;
    } else {
        $($('label[for=checkbox2]')[0]).css({'color': 'red', 'text-decoration': 'underline'});
    }
    if (!correct_direct || !correct_dates || !correct_sport) {
        scrollToElem(direct_el);
        if (!correct_direct) {
            direct_el.css('border', '1px solid red');
        }
        if (!correct_dates) {
            period_tour.css('border', '1px solid red');
        }
        if (!correct_sport) {
            active_sport.css('border', '1px solid red');
        }
    } else if (!tourists_list) {
        scrollToElem(tourists_list_el);
    } else if (!insurer_correct) {
        scrollToElem(insurer_el);
    } else if (!accept_terms) {
        scrollToElem(terms_el);
    }

    if (correct_direct && correct_dates && correct_sport && insurer_correct && tourists_list && accept_terms) {
        all_right = true;
    }
    return all_right;
}

function checkNotEmptyAllFields(obj = {}) {
    let allEmptiesFields = [];
    for (let key in obj) {
        if (key === "insurer_bdate") {

            if (!checkDateFormat(obj[key]) || !date_more_18(obj[key])) {
                $(`#${key}`).css('border', '1px solid pink');
                allEmptiesFields.push(key);
            }
        } else if (key === "insurer_email") {
            if (!validateEmail(obj[key])) {
                $(`#${key}`).css('border', '1px solid red');
                allEmptiesFields.push(key);
            }
        } else if (key === "insurer_phone") {
            if (!validatePhone(obj[key])) {
                $(`#${key}`).css('border', '1px solid red');
                allEmptiesFields.push(key);
            }
        } else if (obj[key] === "") {
            $(`#${key}`).css('border', '1px solid red');
            allEmptiesFields.push(key);
        }
    }
    return allEmptiesFields.length === 0;
}

function date_more_18(date_str = null) {
    if (date_str !== null) {
        let d = new Date(date_str);
        let t = new Date();
        t.setFullYear(t.getFullYear() - 18);
        return d.getTime() <= t.getTime();
    } else {
        return false;
    }
}

function maxDate() {
    let t = new Date();
    // t.setFullYear(t.getFullYear() - 85);
    t.setFullYear(t.getFullYear() - 100);
    return t.getTime();

}
function date_more_85(date_str = null) {
    if (date_str !== null) {
        let d = new Date(date_str);
        return d.getTime() >= maxDate();
    } else {
        return false;
    }
}

function checkCorrectTouristsList() {
    let emptyAllTourists = [];
    let allElements = $('.inner-tourist');
    for (let i = 0; i < allElements.length; i++) {
        let eachElem = $(allElements[i]);
        let tourist_fname_el = eachElem.find('input[name="tourist_fname[]"]');
        let tourist_fname = tourist_fname_el.val();
        let tourist_lname_el = eachElem.find('input[name="tourist_lname[]"]');
        let tourist_lname = tourist_lname_el.val();
        let tourist_passport_el = eachElem.find('input[name="tourist_passport[]"]');
        let tourist_passport = tourist_passport_el.val();
        let tourist_bdate_el = eachElem.find('input[name="tourist_bdate[]"]');
        let tourist_bdate = getDateForRequest(tourist_bdate_el.val());
        let each_obj = {
            "tourist_fname": tourist_fname,
            "tourist_lname": tourist_lname,
            "tourist_bdate": tourist_bdate,
            "tourist_passport": tourist_passport
        };
        let validInfoOldTurist = date_more_85(tourist_bdate);
        if (tourist_fname === "" || tourist_lname === "" || tourist_passport === "" || tourist_bdate === "" || !checkDateFormat(tourist_bdate) || !validInfoOldTurist) {
            emptyAllTourists.push(each_obj);
            for (let key in each_obj) {
                if (key === "tourist_fname" && each_obj[key] === "") {
                    $(tourist_fname_el).css('border-bottom', '3px solid red');

                }
                if (key === "tourist_lname" && each_obj[key] === "") {
                    $(tourist_lname_el).css('border-bottom', '3px solid red');
                }
                if (key === "tourist_passport" && each_obj[key] === "") {
                    $(tourist_passport_el).css('border-bottom', '3px solid red');
                }
                if (key === "tourist_bdate" && (each_obj[key] === "" || !checkDateFormat(each_obj[key]))) {
                    $(tourist_bdate_el).css('border-bottom', '3px solid red');
                }
                if (key === "tourist_bdate" && !validInfoOldTurist) {
                    $(tourist_bdate_el).css('border-bottom', '3px solid red');
                    $('.age-tourists').css('display','block');
                }
            }
        }
    }
    return emptyAllTourists.length === 0;
}

function checkCorrectDateFrom(date_str = null) {

    if (date_str !== null) {
        let d = new Date(date_str);
        d.setHours(0);

        let t = new Date();
        t.setHours(0);
        t.setMinutes(0);
        t.setSeconds(0);
        t.setMilliseconds(0);
        return d.getTime() >= t.getTime();
    } else {
        return false;
    }
}

function checkCorrectDateTo(date_from = null, date_to = null) {
    if (date_from !== null && date_to !== null) {
        let d = new Date(date_from);
        let t = new Date(date_to);
        return t.getTime() > d.getTime();
    } else {
        return false;
    }
}

function scrollToElem(elem = null) {
    if (elem !== null && $(elem).offset()) {
        $('html, body').animate({
            scrollTop: $(elem).offset().top
        }, 500);
        return true;
    } else {
        return false;
    }
}

function checkDateFormat(str_date = null) {
    if (str_date !== null) {
        let reg_date_format = /^\d{4}-\d{2}-\d{2}$/gm;
        return reg_date_format.test(str_date);
    } else {
        return false;
    }
}

function validateEmail(email = null) {
    if (email !== null) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    } else {
        return false;
    }
}

function validatePhone(phone = null) {
    if (phone !== null) {
        // let re_num = /^.?[0-9]{8,14}$/gm;
        let re_num = /^.?[0-9]{5,}$/gm;
        if (re_num.test(phone)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }

}

function daysName(days_count = 0) {
    let day_num = parseInt(days_count);
    let day_str = days_count.toString();
    if (day_num < 20) {
        let days_name = daysNameByRange(day_num);
        return localStorage.getItem(days_name);
    } else {
        let part_num = day_str.substr(-2, 2);
        let days_name = daysNameByRange(parseInt(part_num));
        return localStorage.getItem(days_name);
    }
}

function daysNameByRange(num = 0) {
    if (num === 0) {
        return 'z_days';
    } else if (num === 1) {
        return 'o_day';
    } else if (num > 1 && num < 5) {
        return 'f_day';
    } else if (num >= 5 && num < 21) {
        return 'z_days';
    } else {
        return 'z_days';
    }
}

function countTouristsFoDel() {
    let all_tourists = $('.inner-tourist');
    if (all_tourists.length > 0) {
        $(all_tourists).find('span.del-tourist').removeClass('d-none');
    } else {
        if (!$(all_tourists[0]).find('span.del-tourist').hasClass('d-none')) {
            $(all_tourists[0]).find('span.del-tourist').addClass('d-none');
        }
    }
}

function openModal() {
    document.getElementById('overlay').style.display = 'block';
    document.getElementById('signatureModal').style.display = 'block';
}

function closeModal() {
    document.getElementById('overlay').style.display = 'none';
    document.getElementById('signatureModal').style.display = 'none';
}


function showLoader() {
    document.getElementById('overlay').style.display = 'block';
    document.getElementById('loaderModal').style.display = 'block';
}

function hideLoader() {
    document.getElementById('overlay').style.display = 'none';
    document.getElementById('loaderModal').style.display = 'none';
}

function getSelectedAdditionOptions() {
    const selectedAdditionalOptionCards = Array.from(document.getElementsByClassName('body-form__addition--selected'));

    return selectedAdditionalOptionCards.map(({dataset: {id, price}}) => [ Number(id), Number(price) ]);
}

function toggleAdditionOption(e) {
    const wrapper = e.target.closest('.body-form__addition');
    const button = e.target.closest('button');

    if (wrapper && button) {
        wrapper.classList.toggle('body-form__addition--selected');
        calculateOrder();
    }
}

$(document).ready(function () {
    setTerritory();
    // initTouristDate();
    // initInsurerDate();
    setSportSelected();
    calculateOrder();
    countTouristsFoDel();
});

const multiSelects = {
	buyMultiSelect: 	{
		triggerClass:'buy__form-control--multiselect',
		contentClass: 'buy__form-control--list',
	}
};
const buyMultiSelect = toggleSelect(multiSelects.buyMultiSelect);
const multiSelect = createMultiSelect({ multiSelectClass: 'buy__form-control--multiselect' });
const filterTerritoriesSelect = filterMultiSelect({
    hiddenClass: 'buy__form-control--hidden',
    activeClass: 'buy__form-control--select--active',
    selectedClass: 'buy__form-control--selected',
});

function addClassToElement(element, className, modifier = '') {
    if (element && !element.classList.contains(className + modifier)) {
        element.classList.add(className + modifier);
    }
}
function removeClassFromElement(element, className, modifier = '') {
    if (element && element.classList.contains(className + modifier)) {
        element.classList.remove(className + modifier);
    }
}

function toggleSelect ({ triggerClass }) {
	const modifier = '--active';
	const showSelectList = (e) => {
		const { target } = e;
		const menuTrigger = target.closest('.' + triggerClass);

		hideAllLists();
		addClassToElement(menuTrigger, triggerClass, modifier);
	}

	const hideAllLists = () => {
		const collection = document.getElementsByClassName(triggerClass);

		for (const collectionElement of collection) {
			removeClassFromElement(collectionElement, triggerClass, modifier);
		}
	}
	const hideSelectList = (e) => {
		const { target } = e;
		const menuTrigger = target.closest('.' + triggerClass);

		removeClassFromElement(menuTrigger, triggerClass, modifier);
	}
	const toggleSelectList = (e) => {
		const { target } = e;
		const menuTrigger = target.closest('.' + triggerClass);

		menuTrigger.classList.toggle(triggerClass + modifier);
	}

	return {
		triggerClass,
		showSelectList,
		hideSelectList,
		toggleSelectList,
		hideAllLists,
	}
}
function createMultiSelect ({ multiSelectClass }) {
	const reset = () => {
		const buttons = listWrapper.getElementsByTagName('button');
		const options = optionsWrapper.children;

		Array.from(buttons).forEach(button => {
			button.parentElement.remove();
		});
		Array.from(options).forEach(option => {
			removeClassFromElement(option, 'buy__form-control--selected');
		})
	}
	const getEntries = (wrapper, tagName) => {
		const elements = wrapper.getElementsByTagName(tagName);

		return Array.from(elements)
			.map(({ dataset: { text, value }}) => [ text, value ]);
	}
	const validate = () => {
		const entries = getEntries(listWrapper, 'button')
			.map(value => JSON.stringify(value));
		const options = getEntries(optionsWrapper, 'a')
			.map(value => JSON.stringify(value));
		let isValid = true;

		if (!entries.length) {
			return false;
		}

		entries.forEach(value => {
			if (!options.includes(value)) {
				isValid = false;
			}
		});

		return isValid;
	}
	const multiSelectWrapper = document.getElementsByClassName(multiSelectClass)[0];
	const listWrapper = multiSelectWrapper.firstElementChild;
	const optionsWrapper = multiSelectWrapper.lastElementChild.firstElementChild;


	return {
		groupWrapper: multiSelectWrapper.parentElement,
		getSelectEntries: () => getEntries(listWrapper, 'button'),
		// getOptionsEntries: () => getEntries(optionsWrapper, 'a'),
		validate,
		reset,
	};
}
function filterMultiSelect({ hiddenClass, activeClass, selectedClass }) {
	return (e) => {
		const { target, key } = e
		const { value } = target;
		const filteredKeys = [ 'Backspace', 'Delete' ];
		const controlElement = target.closest('.buy__form-control--multiselect');

		const listCollection = controlElement.lastElementChild.firstElementChild.children;
		let notHiddenItemsCount = 0;

		for (const element of listCollection) {
			const { textContent } = element.firstElementChild;

			if (textContent.toLowerCase().includes(value.trim().toLowerCase())) {
				removeClassFromElement(element, hiddenClass);
				notHiddenItemsCount++;
			} else {
				addClassToElement(element, hiddenClass);
			}
		}
	}
}
function removeHiddenClassFromCollection (listCollection, hiddenClass) {
	for (const element of listCollection) {
		removeClassFromElement(element, hiddenClass);
	}
}
function createSelectItem (itemClass, text, value) {
	const itemWrapper = document.createElement('div');
	const textSpan = document.createElement('span');
	const image = document.createElement('img');
	const button = document.createElement('button');

	image.src = '/assets/img/form/modal-close.svg';
	image.setAttribute('alt', 'Remove territory');
	button.setAttribute('data-text', text);
	button.setAttribute('data-value', value);
	button.setAttribute('data-remove-territory', value);
	button.setAttribute('type', 'button');
	button.appendChild(image);
	textSpan.textContent = text;
	itemWrapper.classList.add(itemClass);
	itemWrapper.append(textSpan, button);

	return itemWrapper;
}
function buttonClickHandler (e) {
	const button = e.target.closest('button[type="button"]');
	const actions = {
		removeTerritory: ({ value }) => {
			const territoryItem = button.parentElement;
			const controlElement = territoryItem.closest('.buy__form-control--multiselect');
			const multiSelectElements = controlElement.lastElementChild.firstElementChild.children;

			territoryItem.remove();
			Array.from(multiSelectElements).forEach(listElement => {
				const { dataset } = listElement.firstElementChild;

				if (dataset.value === value) {
					listElement.classList.remove('buy__form-control--selected');
				}
			});

			if (!multiSelect.getSelectEntries().length) {
				// showPlaceholder({target: document.querySelector('input[name="territories"]')});
			}

			calculateOrder();
		},
	}

	if (!button) {
		return;
	}

	const { dataset } = button;

	for (const action in actions) {
		if (dataset.hasOwnProperty(action)) {
			actions[action](dataset);
		}
	}
}
function liClickHandler (e){
	const li =  e.target.closest('li');

	if (!li || !li.firstElementChild) {
		return;
	}

	const { dataset } = li.firstElementChild;
	const selectedClass = 'buy__form-control--selected';

	if (!dataset.setInput || dataset.setInput !== 'territories') {
		return;
	}

	const input = document.querySelector(`input[name="${dataset.setInput}"]`);
	const itemClass = 'buy__form-control--multiselect-list-item';
	const controlElement = li.closest('.buy__form-control--multiselect');
	const linksElement = li.closest('.buy__form-links');
	let insertedElement = null;
	const { groupWrapper, validate, getSelectEntries } = multiSelect;

	if (controlElement) {
		if (li.classList.contains(selectedClass)) {
			const buttons = controlElement.firstElementChild.getElementsByTagName('button');

			removeClassFromElement(li, selectedClass);
			Array.from(buttons).forEach(button => {
				if (button.dataset.value === dataset.value) {
					button.parentElement.remove();
				}
			});

			if (!getSelectEntries().length) {
				// showPlaceholder({target: input});
			}
		} else {
			const listCollection = controlElement.lastElementChild.firstElementChild.children;

			insertedElement = input.parentElement.insertBefore(createSelectItem(itemClass, dataset.text, dataset.value), input);
			addClassToElement(li, selectedClass);
			removeHiddenClassFromCollection(listCollection, 'buy__form-control--hidden');
            removeClassFromElement(controlElement, 'buy__form-control', '--error');
			input.value = '';
			input.placeholder = '';
		}

        calculateOrder();
	}

	if (linksElement) {
		const groupWrapper = linksElement.parentElement;
		const controlElement = groupWrapper.firstElementChild.nextElementSibling;
		const listCollection = controlElement.lastElementChild.firstElementChild.children;
		const buttons = controlElement.firstElementChild.getElementsByTagName('button');
		const isValueExists = Array.from(buttons)
			.some(button => button.dataset.value === dataset.value);

		if (!isValueExists) {
			insertedElement = input.parentElement.insertBefore(createSelectItem(itemClass, dataset.text, dataset.value), input);

			Array.from(listCollection).forEach(listElement => {
				if (listElement.firstElementChild.dataset.value === dataset.value) {
					addClassToElement(listElement, selectedClass);
				}
			});

			input.value = '';
			input.placeholder = '';
		}
	}

	if (!controlElement && !linksElement) {
		return;
	}

	// updateBuyFormPrice();
}
function createAnchorClickHandler (actions) {
    return (e) => {
        const { dataset, tagName } = e.target;

        if (tagName !== 'A') {
            return;
        }

        let isActionExists = false;

        for (const action in actions) {
            if (dataset.hasOwnProperty(action)) {
                isActionExists = true;
                actions[action](dataset);
            }
        }

        if (isActionExists) {
            e.preventDefault();
        }
    }
}
function throttle(fn, delay) {
	let lastCall = 0;

	return function (...args) {
		const now = Date.now();

		if (now - lastCall >= delay) {
			fn.apply(this, args);
			lastCall = now;
		}
	};
}

function sendRequest(url, options = {}) {
    // Check if native fetch exists
    if (typeof fetch === 'function') {
        return fetch(url, options);
    }

    // Fallback to XMLHttpRequest
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        // Set method, defaults to GET
        const method = (options.method || 'GET').toUpperCase();

        // Handle timeout
        xhr.timeout = options.timeout || 0;

        // Open request
        xhr.open(method, url, true);

        // Set headers
        if (options.headers) {
            Object.entries(options.headers).forEach(([key, value]) => {
                xhr.setRequestHeader(key, value);
            });
        }

        // Set credentials
        if (options.credentials === 'include') {
            xhr.withCredentials = true;
        }

        // Handle response
        xhr.onload = () => {
            const response = {
                ok: xhr.status >= 200 && xhr.status < 300,
                status: xhr.status,
                statusText: xhr.statusText,
                headers: xhr.getAllResponseHeaders().split('\r\n').reduce((acc, current) => {
                    const [name, value] = current.split(': ');
                    if (name) acc[name.toLowerCase()] = value;
                    return acc;
                }, {}),
                url,
                text: () => Promise.resolve(xhr.responseText),
                json: () => Promise.resolve(JSON.parse(xhr.responseText)),
                blob: () => Promise.resolve(new Blob([xhr.response])),
            };

            resolve(response);
        };

        // Handle errors
        xhr.onerror = () => {
            reject(new TypeError('Network request failed'));
        };

        xhr.ontimeout = () => {
            reject(new TypeError('Network request failed'));
        };

        // Send request
        const body = options.body;
        if (body && typeof body === 'object') {
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify(body));
        } else {
            xhr.send(body);
        }
    });
}

function updateSelectedItem (listElements, value, selectedClass) {
	for (const listElement of listElements) {
		const { dataset } = listElement.firstElementChild;

		if (dataset.value === value) {
			addClassToElement(listElement, selectedClass);
		} else {
			removeClassFromElement(listElement, selectedClass);
		}
	}
}

function downloadMultiOptions ({ url, method, inputSelector, dataAttribute, attributeValue  }, withLinks = false) {
	const getOptionListWrapperElement = (inputSelector) => {
		return  document.querySelector('input[name=territories]').parentElement;
	}
	const getOptionListElement = (element) => {
		return element ? element.parentElement.lastElementChild.firstElementChild : null;
	}
	// const getLinksListElement = (element) => {
	// 	return element ? element.parentElement.parentElement.lastElementChild : null;
	// }
	const createLinkListElement = (id, text, associationText, dataAttribute, attributeValue) => {
		const li = document.createElement('li');
		const a = document.createElement('a');

		a.textContent = associationText;
		a.href = '#';
		a.setAttribute('data-text', text);
		a.setAttribute('data-value', id);
		a.setAttribute(dataAttribute, attributeValue);
		li.appendChild(a);

		return li;
	}
	const wrapper =  getOptionListWrapperElement(inputSelector);
	const optionList = getOptionListElement(wrapper);
	// const linkList = getLinksListElement(wrapper);

	sendRequest(url, { method })
		.then(res => res.json())
		.then(({ response }) => {
			if (!response || !response.success) {
				return;
			}

			const { countries_list } = response;
            const linksPriorities = {
				'207': 'Worldwide',
				'208': 'Europe',
            }
			// const linksAssociations = {
			// 	'207': 'Worldwide',
			// 	'208': 'Europe',
			// 	'100': 'Thailand',
			// 	'107': 'USA',
			// }
			const optionElements = [];
			// const linkElements = [];

			optionList.innerHTML = '';
			// linkList.innerHTML = '';
            Object.keys(linksPriorities).forEach(priority_id => {
                const country = countries_list.find(({id}) => id == priority_id);

                if (country) {
                    optionElements.push(createLinkListElement(country.id, country.text, country.text, dataAttribute, attributeValue));
                }
            })
			countries_list
                .filter(({id}) => !linksPriorities.hasOwnProperty(`${id}`))
                .forEach(({id, text}) => {
                    optionElements.push(createLinkListElement(id,text, text, dataAttribute, attributeValue));
                });
            updateSelectedItem(optionElements, '207', 'buy__form-control--selected');
			optionList.append(...optionElements);
		}).catch(e => console.error(e.message))
}

downloadMultiOptions({
	url: '/api/get_country_list',
	method: 'POST',
	inputSelector: 'input[name="territories"]',
	dataAttribute: 'data-set-input',
	attributeValue: 'territories',
});

function checkPaymentStatus (order_id = '176046', step = 5 * 1000) {
    if (!order_id) {
        return;
    }

    const statuses = {
        CREATED: 1,
        PAID: 2,
        CANCELLED: 3,
    }
    const interval = setInterval((order_id) => {
        sendRequest('/api/get_status_policy', {
            method: 'POST', body:JSON.stringify({ request: { order_id }})
        }).then(res => res.json()).then(({ response }) => {
            if (!response || !response.success) {
                clearInterval(interval);
                hideLoader();
            }

            switch (response.status) {
                case statuses.CANCELLED:
                    clearInterval(interval);
                    hideLoader();

                    return;
                case statuses.PAID:
                    const { origin } = window.location;

                    window.location.replace(`${origin}/thanks`);
                    
                    return;
                default:
                    return;
            }
            
        }).catch(e => console.error(e.message));
    }, step, order_id);
}


const territoryBtn = document.getElementById('toggle_territory');
const territoriesInput = document.getElementById('territories_input');
const anchorActions = {
	setInput: ({ setInput, text, value }) => {
		return
	},
}

territoryBtn.addEventListener('click', buyMultiSelect.toggleSelectList);
territoriesInput.addEventListener('keyup', throttle(filterTerritoriesSelect, 300));
territoriesInput.addEventListener('focus', buyMultiSelect.showSelectList);
document.body.addEventListener('click', createAnchorClickHandler(anchorActions));
document.body.addEventListener('click', buttonClickHandler);
document.body.addEventListener('click', liClickHandler);
document.body.addEventListener('click', (e) => {
	const { target } = e;
    // const { tagName, dataset } = target;
	const { triggerClass, hideAllLists } = buyMultiSelect;
	const selectTrigger = target.closest('.' + triggerClass);

	if (selectTrigger) {
		return;
	}

    // if (tagName === 'A' && dataset.hasOwnProperty('setInput')) {
    //     e.preventDefault();
    // }

	hideAllLists();
});


document.addEventListener('DOMContentLoaded', () => {
    function accordions() {
        const accordions = document.querySelectorAll('.accordion');
        accordions.forEach(accordion => {
            const accordionItems = accordion.querySelectorAll('.accordion__item');
            accordionItems.forEach(el => {
                const subAccordion = el.querySelector('.sub-accordion');
                el.addEventListener('click', (e) => {

                    const self = e.currentTarget;
                    const control = self.querySelector('.accordion__control');
                    const title = self.querySelector('.accordion__title');
                    const content = self.querySelector('.accordion__content');

                    if (e.target.closest('.accordion__control')) {
                        self.classList.toggle('open');

                        if (self.classList.contains('open')) {
                            control.setAttribute('aria-expanded', true);
                            content.setAttribute('aria-hidden', false);
                            content.style.maxHeight = content.scrollHeight + 'px';
                        } else {
                            control.setAttribute('aria-expanded', false);
                            content.setAttribute('aria-hidden', true);
                            content.style.maxHeight = null;
                        }
                    }
                })
                if (subAccordion) {
                    const accordionItems = subAccordion.querySelectorAll('.sub-accordion__item');
                    accordionItems.forEach(el => {
                        const parent = el.parentNode;

                        const control = el.querySelector('.sub-accordion__control');
                        const content = el.querySelector('.sub-accordion__content');


                        el.addEventListener('click', (e) => {

                            if (content) {
                                const self = e.currentTarget;
                                const control = self.querySelector('.sub-accordion__control');
                                const title = self.querySelector('.sub-accordion__title');
                                const content = self.querySelector('.sub-accordion__content');


                                if (e.target.closest('.sub-accordion__control')) {

                                    self.classList.toggle('open');

                                    if (self.classList.contains('open')) {
                                        control.setAttribute('aria-expanded', true);
                                        content.setAttribute('aria-hidden', false);
                                        content.style.maxHeight = content.scrollHeight + 'px';
                                        parent.style.maxHeight = parseInt(parent.offsetHeight) + parseInt(content.style.maxHeight) + 'px';

                                    } else {
                                        control.setAttribute('aria-expanded', false);
                                        content.setAttribute('aria-hidden', true);
                                        parent.style.maxHeight = parseInt(parent.style.maxHeight) - parseInt(content.offsetHeight) + 'px';
                                        content.style.maxHeight = null;
                                    }


                                }

                            }

                        })

                    })
                }
            })
        })
    }
    let elem = [];
    function checkRightFill() {
        const validateInputs = document.querySelectorAll('*[data-validate="1"]');
        // const regExpLatLetter = /^[a-zA-Z]+$/;
        const regExpLatLetter = /^[a-zA-Z]+(?:[- ][a-zA-Z]+)*$/;
        const regExpDate = /(((0[1-9]|[12]\d|3[01])\.(0[13578]|1[02])\.((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\.(0[13456789]|1[012])\.((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\.02\.((19|[2-9]\d)\d{2}))|(29\.02\.((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/;
        const regExpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i;
        // const re_num = /^.?[0-9]{8,14}$/gm;
        const re_num = /^.?[0-9]{5,}$/gm;
        const regExpPasport = '';
        const selectorForNameType = 'form-control__name';
        const selectorForSurNameType = 'form-control__surname';
        const selectorForBirthday = 'form-control__birthday';
        const selectorForBirthdaySt = 'form-control__birthday-st';
        const selectorForOldBirthday = 'form-control__birthday-old';
        const selectorForEmail = 'form-control__email';
        const selectorForPasport = 'form-control__pasport';
        const selectorForTel = 'form-control__tel';
        const nameMessage = errorNameMessage;
        const surnameMessage = errorLnameMessage;
        const dateMessage = errorBdayMessage;
        const dateRulesMessage = errorStandartBdayMessage;
        const dateMaxOldMessage = errorMaxBdayMessage;
        const emaleMessage = errorEmaleMessage;
        const pasportMessage = errorPasportMessage;
        const phoneMessage = errorPhoneMessage;
        const errorIconPath = 'url("./img/form/error.svg")';
        const okIconPath = 'url("./img/form/valide.svg")';

        validateInputs.forEach((input, index) => {
            if (!input.classList.contains('is-blur') || input.classList.contains('is-blur')) {
                input.classList.add('is-blur');
                input.addEventListener('blur', (e) => {
                    const errorBlock = input.closest('.form-control').querySelector('.error');
                    const warnIcon = input.closest('.form-control').querySelector('.warn-icon');
                    errorBlock.textContent = '';
                    if (input.value) {
                        if (input.classList.contains(selectorForNameType)) {
                            if (!regExpLatLetter.test(input.value.trim())) {
                                warnIcon.classList.remove('warn-icon--ok');
                                warnIcon.classList.add('warn-icon--error');
                                errorBlock.textContent = nameMessage;
                                if( elem.indexOf(selectorForNameType) === -1){
                                    elem.push(selectorForNameType);
                                }
                            } else {
                                warnIcon.classList.add('warn-icon--ok');
                                warnIcon.classList.remove('warn-icon--error');
                                elem.splice(elem.indexOf(selectorForNameType));
                            }
                        }
                        if (input.classList.contains(selectorForSurNameType)) {

                            if (!regExpLatLetter.test(input.value.trim())) {
                                warnIcon.classList.remove('warn-icon--ok');
                                warnIcon.classList.add('warn-icon--error');
                                errorBlock.textContent = surnameMessage;
                                if( elem.indexOf(selectorForSurNameType) === -1){
                                    elem.push(selectorForSurNameType);
                                }
                            } else {
                                warnIcon.classList.add('warn-icon--ok');
                                warnIcon.classList.remove('warn-icon--error');
                                elem.splice(elem.indexOf(selectorForSurNameType));
                            }
                        }

                        if (input.classList.contains(selectorForBirthday)) {

                            let changeFormBDate = getDateForRequest(input.value);
                            if (!date_more_18(changeFormBDate)) {
                                warnIcon.classList.remove('warn-icon--ok');
                                warnIcon.classList.add('warn-icon--error');
                                errorBlock.textContent = dateRulesMessage;
                                if(elem.indexOf(selectorForBirthdaySt) === -1){
                                    elem.push(selectorForBirthdaySt);
                                }
                            }
                            if (!date_more_85(changeFormBDate) && $('.block-tourist').length===0) {
                                warnIcon.classList.remove('warn-icon--ok');
                                warnIcon.classList.add('warn-icon--error');
                                errorBlock.textContent = dateMaxOldMessage;
                                if(elem.indexOf(selectorForOldBirthday) === -1) {
                                    elem.push(selectorForOldBirthday);
                                }
                            }else {
                                if (!regExpDate.test(input.value)) {
                                    warnIcon.classList.remove('warn-icon--ok');
                                    warnIcon.classList.add('warn-icon--error');
                                    errorBlock.textContent = dateMessage;
                                    elem.splice(elem.indexOf(selectorForBirthdaySt));

                                } else {
                                    warnIcon.classList.add('warn-icon--ok');
                                    warnIcon.classList.remove('warn-icon--error');
                                    elem.splice(elem.indexOf(selectorForBirthdaySt));
                                }
                            }

                        }
                        if (input.classList.contains(selectorForPasport)) {

                            if (regExpPasport) {
                                warnIcon.classList.remove('warn-icon--ok');
                                warnIcon.classList.add('warn-icon--error');
                                errorBlock.textContent = pasportMessage;
                            } else {
                                warnIcon.classList.add('warn-icon--ok');
                                warnIcon.classList.remove('warn-icon--error');
                            }
                        }
                        if (input.classList.contains(selectorForTel)) {

                            if ( !re_num.test(input.value)) {
                                warnIcon.classList.remove('warn-icon--ok');
                                warnIcon.classList.add('warn-icon--error');
                                errorBlock.textContent = phoneMessage;
                                if( elem.indexOf(selectorForTel) === -1){
                                    elem.push(selectorForTel);
                                }
                            }else {
                                warnIcon.classList.add('warn-icon--ok');
                                warnIcon.classList.remove('warn-icon--error');
                                elem.splice(elem.indexOf(selectorForTel));
                            }
                        }

                        if (input.classList.contains(selectorForEmail)) {

                            if (!regExpEmail.test(input.value)) {
                                warnIcon.classList.remove('warn-icon--ok');
                                warnIcon.classList.add('warn-icon--error');
                                errorBlock.textContent = emaleMessage;
                                if( elem.indexOf(selectorForEmail) === -1){
                                    elem.push(selectorForEmail);
                                }
                            } else {
                                warnIcon.classList.add('warn-icon--ok');
                                warnIcon.classList.remove('warn-icon--error');
                                elem.splice(elem.indexOf(selectorForEmail));

                            }
                        }
                    } else {
                        warnIcon.classList.remove('warn-icon--error', 'warn-icon--ok');
                        errorBlock.textContent = '';
                    }
                });
            }

        });

        return elem.length===0;
    }
    $('#checkbox2').on('click', function () {
        $('.error-contract__title').html('');
    });
    $('input').on('change', function (){
        checkRightFill();
    });
    function form() {
        const steps = document.querySelectorAll('.body-form__step');
        const prevBtn = document.querySelector('.body-form__prev');
        const nextvBtn = document.querySelector('.body-form__next');
        const timelineItems = document.querySelectorAll('.timeline-tour__item');

        checkRightFill();
        toClickField();

        $(document).ready(function () {
            $('.form-control--birthday input').mask("99.99.9999", {placeholder: 'DD.MM.YYYY'});
        })


        function formBtnClicks() {
            if (!iti) {
                initCountryPhone()
            };
            const formBlock = document.querySelector('.body-form');
            const formSection = document.querySelector('.tour-insurrance');

            let clicksCount = 0;
            let progressBarHeight = 0;
            const addNum = 100 / 3;

            function nextClick() {

                nextvBtn.addEventListener('click', (e) => {
                    input.addEventListener('blur', function () {
                        if (input.value.trim()) {
                            var number = iti.getNumber();
                            $('#get_full_number_insurer').val(number);
                        }
                    });

                    const countriesBlock = document.getElementsByClassName('buy__form-control--multiselect')[0];
                    const isTerritoriesValid = multiSelect.validate();
                    const isConfirmed = $('#checkbox2').is(':checked');

                    if (!clicksCount && !isTerritoriesValid) {
                        addClassToElement(countriesBlock, 'buy__form-control', '--error');
                    }

                    if (isConfirmed && isTerritoriesValid) {
                        $('#checkbox2').prop('checked', true).attr('checked', 'checked');
                        e.preventDefault();
                        $('.body-form__prev').css('opacity', '1');
                        let stepsBlock = steps[clicksCount];
                        let isValide = isEmptyValidate(stepsBlock);
                        let isValideMistake = checkRightFill();
                        let isValideEmtyFields = checkCorrectTouristsList();

                        if (clicksCount !== steps.length - 1) {



                            if (!isValide || !isValideMistake) {


                            } else {
                                clicksCount++;
                                progressBarHeight += addNum;
                                deleteClasses('.body-form__step', 'is-active');
                                steps[clicksCount].classList.add('is-active');
                                timelineItems[clicksCount].classList.add('is-active');
                                addProgress(progressBarHeight);
                                if (clicksCount === steps.length - 1) {
                                    let formStepThree = $('.last-step__price');
                                    scrollToElem(formStepThree);
                                    $('.body-form__next').css('display', 'none');
                                    $('.btn_blue').css('display', 'revert');
                                    let checkForm = getOrderDetails();
                                    let country = $('#tour_direct option:selected').text();
                                    let countries = multiSelect.getSelectEntries().map(([country]) => country).join(', ');
                                    $('.last-step__general').empty();
                                    $('.last-step__general').append(`
                                <div class="last-step__field field-step">
                                <span class="field-step__title field-step__date">${travelDates}</span>
                                <div class="field-step__value">
                                    <span class="value-date">${checkForm.date_from}/${checkForm.date_to}</span>
                                </div>
                            </div>
                            <div class="last-step__field field-step">
                                <span class="field-step__title">${tariff}</span>
                                <div class="field-step__value">${titleTariff}</div>
                            </div>
                            <div class="last-step__field field-step">
                                <span class="field-step__title">${selectCountry}</span>
                                <div class="field-step__value">
                                    <span class="value-country">${countries}</span>
                                </div>
                            </div>
                                `);
                                    $('.last-step__insuring').empty();
                                    $('.last-step__insuring').append(`
                                <div class="last-step__field field-step">
                                <span class="field-step__title">${fio}</span>
                                <div class="field-step__value">
                                    <span class="value-fio">${checkForm.insurer.first_name} ${checkForm.insurer.last_name}</span>
                                </div>
                            </div>
                            <div class="last-step__field field-step">
                                <span class="field-step__title">${birthday}</span>
                                <div class="field-step__value">
                                    <span class="value-bdate">${checkForm.insurer.birth_date}</span>
                                </div>
                            </div>
                            <div class="last-step__field field-step">
                                <span class="field-step__title">${passport}</span>
                                <div class="field-step__value">
                                    <span class="value-pasport">${checkForm.insurer.passport}</span>
                                </div>
                            </div>
                            <div class="last-step__field field-step">
                                <span class="field-step__title">${email}</span>
                                <div class="field-step__value">
                                    <span class="value-email">${checkForm.insurer.email}</span>
                                </div>
                            </div>
                            <div class="last-step__field field-step">
                                <span class="field-step__title">${contactPhone}</span>
                                <div class="field-step__value">
                                    <span class="value-phone">${checkForm.insurer.phone}</span>
                                </div>
                            </div>
`)
                                    $('.last-step__tourists').empty();
                                    checkForm.tourists.forEach(function (item, i) {
                                        $('.last-step__tourists').append(`

                     <h4>
                        ${touristTrip}: №${i + 1}.
                    </h4>

                        <div class="last-step__tourist">
                            <div class="last-step__field field-step">
                      <span class="field-step__title">
                        ${fio}
                      </span>
                                <div class="field-step__value">
                                    ${item.fname} ${item.lname}
                                </div>
                            </div>
                            <div class="last-step__field field-step">
                      <span class="field-step__title">
                        ${passport}
                      </span>
                                <div class="field-step__value">
                                    ${item.passport}
                                </div>
                            </div>
                            <div class="last-step__field field-step">
                      <span class="field-step__title">
                        ${birthday}
                      </span>
                                <div class="field-step__value">
                                    ${item.birthday}
                                </div>
                            </div>
                        </div>
`);
                                    })
                                }
                            }
                        }
                    } else {
                        // let formStepOne = $('#tour_direct');
                        scrollToElem(countriesBlock);

                        if (!isConfirmed) {
                            $('#checkbox2').prop('checked', false).removeAttr('checked');
                            $('.error-contract__title').html(requiredField);
                        }
                    }
                })
            }

            function prevClick() {
                prevBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (clicksCount === 1){
                        $('.body-form__prev').css('opacity', '0');
                    }
                    const bodyFormOffset = formSection.offsetTop + formBlock.offsetTop;
                    window.scroll({
                        top: bodyFormOffset,
                        left: 0,
                        behavior: "smooth",
                    })
                    if (clicksCount !== 0) {
                        $('.body-form__next').css('display', 'revert');
                        $('.btn_blue').css('display', 'none');
                        timelineItems[clicksCount].classList.remove('is-active');
                        clicksCount--;
                        progressBarHeight -= addNum;
                        deleteClasses('.body-form__step', 'is-active');
                        steps[clicksCount].classList.add('is-active');
                        addProgress(progressBarHeight);

                    }

                })
            }


            nextClick();
            prevClick();

        }



        var input = document.querySelector("#insurer_phone");
        var iti;
        var countryCode;
        var initCountryPhone = function () {
            iti = window.intlTelInput(input, {
                autoHideDialCode: false,
                autoPlaceholder: "aggressive",
                initialCountry: "auto",
                separateDialCode: false,
                formatOnDisplay: false,
                preferredCountries: ["ua", "us", "ru"],
                customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                    let codeCountry = selectedCountryData.dialCode;
                    $('.code_country').html(`(+${codeCountry})`);

                    return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
                },
                geoIpLookup: function (callback) {
                    try {
                        $.get('https://ipinfo.io/?token=e3b605ee58e178', function () {
                        }, "jsonp").always(function (resp) {
                            countryCode = (resp && resp.country) ? resp.country.toLowerCase() : "ua";
                            callback(countryCode);
                        });
                    } catch (e) {
                        countryCode = "ua";
                    }
                },
            });
        }






        function touristActions() {
            let touristCount = 1;
            const controlAdd = document.querySelector('.form-control-add');
            const title = document.querySelector('.form-control-add h4')
            const addBtn = document.querySelector('.body-form__add-tourist');
            let touristBloks;


            controlAdd.addEventListener('click', (e) => {
                e.preventDefault();


                if (e.target === addBtn) {
                    touristBloks = document.querySelectorAll('.body-form__new-tourist');

                    if (!touristBloks.length) {
                        controlAdd.insertAdjacentHTML('beforeend', createInputs(touristCount));
                        touristCount++;
                        controlAdd.insertAdjacentHTML('beforeend', createInputs(touristCount));
                        touristCount++;
                        touristBloks = document.querySelectorAll('.body-form__new-tourist');

                    } else {
                        controlAdd.insertAdjacentHTML('beforeend', createInputs(touristCount));
                        touristBloks = document.querySelectorAll('.body-form__new-tourist');
                        touristCount++;
                    }
                    touristBloks.forEach((el, index) => {
                        if (index % 2) {
                            el.classList.add('is-colored');
                        } else {
                            el.classList.remove('is-colored');
                        }
                    })
                    title.classList.remove('is-hide');
                    checkRightFill();
                    toClickField();
                }

                if (e.target.classList.contains('body-form__remove-tourist') || e.target.closest('.body-form__remove-tourist')) {
                    touristBloks[touristBloks.length - 1].remove();
                    touristCount--;
                    stepInputs = document.querySelectorAll('input[data-req="1"]');
                    touristBloks = document.querySelectorAll('.body-form__new-tourist');
                    if (!touristBloks.length) {
                        title.classList.add('is-hide')
                    }
                    touristBloks.forEach((el, index) => {
                        if (index % 2) {
                            el.classList.add('is-colored');
                        } else {
                            el.classList.remove('is-colored');
                        }
                    })
                }


            })
        }


        function addProgress(progressBarHeight) {
            const progressBar = document.querySelector('.timeline-tour__bar');
            progressBar.style.height = progressBarHeight + '%';
        }


        function isEmptyValidate(stepsBlock) {
            const requiredFields = stepsBlock.querySelectorAll('.form-control--req');
            const requiredInputs = Array.from(stepsBlock.querySelectorAll('.form-control--req [data-req="1"]'));
            const errorBlocks = stepsBlock.querySelectorAll('.form-control--req .error');

            const isEmty = isEmptyFields(requiredInputs);


            function isEmptyFields(fields) {
                return !fields.reduce((acc, field) => {
                    let value;
                    if (field.checked) {
                        field.value = 'on'
                    }
                    return acc *= !!field.value;
                }, 1)
            }


            toMessageForEmpty(requiredInputs, errorBlocks, requiredField)


            return !isEmty;


        }

        function toMessageForEmpty(fields, messageFields, message) {
            fields.forEach((field, index) => {
                if (!field.value) messageFields[index].textContent = message;
            })
        }

        function toClickField() {
            const reqFields = document.querySelectorAll('.form-control--req');
            const errorBloks = document.querySelectorAll('.form-control--req .error');


            reqFields.forEach((field, index) => {
                if (!field.classList.contains('is-clicked')) {
                    field.classList.add('is-clicked');
                    field.addEventListener('click', (e) => {
                        if (errorBloks[index]) {
                            if (errorBloks[index].textContent){
                                errorBloks[index].textContent = '';
                            }
                        }
                        if (field.classList.contains('form-control--birthday')) {
                            const birthdayInput = document.querySelector('.form-control--birthday input');

                            $(document).ready(function () {
                                $('.form-control--birthday input').mask("99.99.9999", {placeholder: 'DD.MM.YYYY'});
                            })
                            $('.form-control--birthday input').attr('placeholder', 'dd.mm.yyyy')

                        }
                        if (e.target.classList.contains('warn-icon')) {

                            field.querySelector('input').focus();

                        }
                        if (e.target.classList.contains('warn-icon--error')) {
                            field.querySelector('input').value = '';
                            field.querySelector('input').focus();
                            e.target.style.backgroundImage = '';
                        }
                    })
                }

            })
        }





        formBtnClicks();
        touristActions();

    }

    function dropdown() {
        const dropdown = document.querySelectorAll('.dropdown');


        dropdown.forEach((el, index) => {
            el.addEventListener('click', (e) => {
                const self = e.target;
                const dropdownTitle = el.querySelector('.dropdown__title');
                const dropdownItems = el.querySelectorAll('.dropdown__item');
                const dropdownMenu = el.querySelector('.dropdown__menu');


                if (self === dropdownTitle) {

                    dropdown.forEach((el, id) => {
                        const dropdownMenu = el.querySelector('.dropdown__menu');

                        if (index !== id) {
                            el.classList.remove('is-active');
                            dropdownMenu.style.maxHeight = null;
                        }
                    })
                    el.classList.toggle('is-active');
                    if (el.classList.contains('is-active')) {
                        dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + 'px';
                    } else {
                        dropdownMenu.style.maxHeight = null;
                    }
                }


                if (el.classList.contains('header__lang')) {
                    dropdownItems.forEach(el => {
                        const itemDropTitle = el.querySelector('.item-dropdown__title');
                        const itemDropSubTitle = el.querySelector('.item-dropdown__subtitle');
                        if (self === el || self === itemDropTitle || self === itemDropSubTitle) {
                            dropdownTitle.textContent = itemDropSubTitle.textContent;
                            dropdownTitle.dataset.title = itemDropTitle.textContent;
                            deleteClasses(dropdownItems, 'is-choised');
                            el.classList.add('is-choised');
                            el.parentNode.parentNode.classList.remove('is-active');
                            dropdownMenu.style.maxHeight = null;
                        }
                    })
                } else {
                    dropdownItems.forEach(el => {
                        const itemDropTitle = el.querySelector('.item-dropdown__title');
                        const itemDropSubTitle = el.querySelector('.item-dropdown__subtitle');
                        if (self === el || self === itemDropTitle || self === itemDropSubTitle) {
                            dropdownTitle.textContent = itemDropSubTitle.textContent;
                            dropdownTitle.dataset.title = itemDropTitle.textContent;
                            deleteClasses(dropdownItems, 'is-choised');
                            el.classList.add('is-choised');
                            el.parentNode.parentNode.classList.remove('is-active');
                            dropdownMenu.style.maxHeight = null;
                        }
                    })
                }


            })
        })


    }

    function burgerMenu() {
        const openBtn = document.querySelector('.burger__btn');
        const closeBtn = document.querySelector('.burger__close');
        const burgerBody = document.querySelector('.burger__body');


        openBtn.addEventListener('click', () => {
            burgerBody.classList.toggle('is-active');
        })
        closeBtn.addEventListener('click', () => {
            burgerBody.classList.remove('is-active');
        })
    }

    function infoPopup() {
        const activeRestBtns = document.querySelectorAll('.sub-accordion__info--act');
        const extremeRestBtns = document.querySelectorAll('.sub-accordion__info--ext');
        const detailBtn = document.querySelector('.side-form__detail');
        const countriesBtn = document.querySelector('.side-form__countries');


        const activeRestWindow = document.querySelector('.active-rest');
        const extremeRestWindow = document.querySelector('.extrime-rest');
        const mergeRestWindow = document.querySelector('.popup-merge');
        const countriesRestWindow = document.querySelector('.countries-rest');

        const allPopups = document.querySelectorAll('.popup-rest');

        allPopups.forEach(el => {
            el.addEventListener('click', (e) => {
                if (e.target === e.currentTarget || e.target === el.querySelector('.popup-close-btn')) {
                    el.classList.remove('is-active');
                    document.body.style.overflow = 'initial';
                }
            })
        })

        activeRestBtns.forEach(el => {
            el.addEventListener('click', () => {
                activeRestWindow.classList.add('is-active');
                document.body.style.overflow = 'hidden';

            })
        })

        extremeRestBtns.forEach(el => {
            el.addEventListener('click', () => {
                extremeRestWindow.classList.add('is-active');
                document.body.style.overflow = 'hidden';

            })
        })

        detailBtn.addEventListener('click', (e) => {
            e.preventDefault();
            mergeRestWindow.classList.add('is-active');
            document.body.style.overflow = 'hidden';

        })

        countriesBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const isCountriesExists =  multiSelect.getSelectEntries().length > 0;
            const ul = countriesRestWindow.getElementsByTagName('ul')[0];

            if (!isCountriesExists || !ul) {
                return;
            }

            ul.textContent = '';
            ul.append(...createCountryLis());
            countriesRestWindow.classList.add('is-active');
            document.body.style.overflow = 'hidden';
        })

    }

    function createCountryLis() {
        return multiSelect.getSelectEntries()
            .map(([text]) => {
                const li = document.createElement('li');

                li.textContent = text.toString();

                return li;
        });
    }

    function toChangeTariff(el) {
        if (el.closest('.card-tariffs')) {
            document.querySelectorAll('.js-tariff-radio').forEach(el => el.checked = false);

            const att = el.closest('.card-tariffs').dataset.tariff;
            document.querySelector(`#${att}`).checked = true;
        }
    }
    $('.card-tariffs__more').click(function () {
        $('.more-block').slideToggle(300)
        $('.more-block, .card-tariffs__more').toggleClass('active')
    })

    document.addEventListener('click', (e) => {
        const dropdown = document.querySelectorAll('.dropdown');
        const burger = document.querySelector('.burger');
        const formDropdown = document.querySelectorAll('.form-dropdown');
        if (!e.target.closest('.dropdown')) {
            dropdown.forEach(el => {
                const dropdownMenu = el.querySelector('.dropdown__menu');

                el.classList.remove('is-active');

            })
        }
        if (!e.target.closest('.burger')) {
            burger.querySelector('.burger__body').classList.remove('is-active');
        }
        if (!e.target.closest('.form-dropdown')) {
            formDropdown.forEach(el => {
                el.classList.remove('is-open');
            })
        }
    })


    function deleteClasses(selector, className) {
        let elements = '';
        if (typeof selector === 'string') {
            elements = document.querySelectorAll(selector);
        } else {
            elements = selector;
        }

        elements.forEach(el => {
            el.classList.remove(className);
        })
    }

    let minDate = new Date();
    let maxDate = new Date();
    maxDate.setDate(minDate.getDate() + 366);


    $(".intro__link, .card-tariffs__link, .card-tariffs__btn").click(function () {
        scrollToBuy();
    });
    function scrollToBuy() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".tour-insurrance__title").offset().top
        }, 1000);
    }





    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            document.getElementById("btn-scroll").style.display = "block";
        } else {
            document.getElementById("btn-scroll").style.display = "none";
        }
    }

    function topFunction() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".header__logo").offset().top
        }, 500);
    }

    $(".btn-start").click(function () {
        topFunction();
    });


















    function getDateForRequest(date = null) {
        if (date === null) {
            return date;
        } else {
            let year = date.substr(6, 4);
            let month = date.substr(3, 2);
            let day = date.substr(0, 2);
            return "" + year + "-" + month + "-" + day;
        }
    }

    function getDateAddDays(add_days = 1, calendar = false) {
        let d = new Date();
        d.setDate(d.getDate() + add_days);
        let year = d.getFullYear();
        let month = addZero(d.getMonth() + 1);
        let day = addZero(d.getDate());
        if (calendar) {
            return "" + day + "." + month + "." + year;
        } else {
            return "" + year + "-" + month + "-" + day;
        }
    }


    // $('#datepicker').change(
    //     function getDates() {
    //         let date_str = $('#datepicker').val();
    //         let dates = date_str.split('-');
    //         let date_from;
    //         let date_to;
    //         if (dates.length >= 1) {
    //             date_from = getDateForRequest(dates[0].trim());
    //             date_to = getDateForRequest(dates[1].trim());
    //         } else {
    //             date_from = getDateAddDays(1);
    //             date_to = getDateAddDays(4);
    //         }
    //
    //         setCountDays(date_from, date_to);
    //         return {
    //             'date_from': date_from,
    //             'date_to': date_to
    //         }
    //     }
    // );

    function daysName(days_count = 0) {
        let day_num = parseInt(days_count);
        let day_str = days_count.toString();
        if (day_num < 20) {
            let days_name = daysNameByRange(day_num);
            return localStorage.getItem(days_name);
        } else {
            let part_num = day_str.substr(-2, 2);
            let days_name = daysNameByRange(parseInt(part_num));
            return localStorage.getItem(days_name);
        }
    }

    function daysNameByRange(num = 0) {
        if (num === 0) {
            return 'z_days';
        } else if (num === 1) {
            return 'o_day';
        } else if (num > 1 && num < 5) {
            return 'f_day';
        } else if (num >= 5 && num < 21) {
            return 'z_days';
        } else {
            return 'z_days';
        }
    }

    dropdown()
    accordions();
    form();
    burgerMenu();
    infoPopup();

    const additionalOptionCards = Array.from(document.getElementsByClassName('body-form__addition'));

    if (additionalOptionCards.length) {
        additionalOptionCards.forEach(additionalOptionCard => {
            additionalOptionCard.addEventListener('click', toggleAdditionOption);
        })
    }
});

